import CustomTabPanel from '../TabPanel'
import GridsHistory from '../GridsHistory'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LuSettings2 } from 'react-icons/lu'
import SubjectsHistory from '../SubjectsHistory'

import CreatedSubject from 'pages/grile/subject-create/createdSubject'
import Tooltip from '@mui/material/Tooltip'
import SavedGridsTab from '../SavedGridsTab'

const HistoryContent = ({
  filterOnMobile,
  setOpen,
  grids,
  filteredGrids,
  subjects,
  isLoading,
  colorByDifficulty,
  addGrila,
  createdSubject,
  savedGrids,
  filteredSavedGrids,
  setSavedGrids,
  isNoteModalOpened,
  setIsNoteModalOpened,
  handleUpdateNote,
  books,
}) => {
  return (
    <>
      <CustomTabPanel value={filterOnMobile} index={0}>
        <SavedGridsTab
          handleUpdateNote={handleUpdateNote}
          isNoteModalOpened={isNoteModalOpened}
          setIsNoteModalOpened={setIsNoteModalOpened}
          setSavedGrids={setSavedGrids}
          isLoading={isLoading}
          savedGrids={savedGrids}
          filteredSavedGrids={filteredSavedGrids}
          colorByDifficulty
          addGrila={addGrila}
        />
        {savedGrids?.length === 0 ? null : (
          <Tooltip title="Filtre">
            <LuSettings2
              className="block cursor-pointer text-over-secondary-background absolute right-[10px] top-[70px]"
              onClick={() => {
                setOpen(true)
              }}
            />
          </Tooltip>
        )}
      </CustomTabPanel>
      {filterOnMobile === 1 ? (
        <CustomTabPanel
          value={filterOnMobile}
          index={1}
          styles={{
            padding: '0 !important',
          }}
        >
          <GridsHistory
            isLoading={isLoading}
            grids={grids}
            filteredGrids={filteredGrids}
            colorByDifficulty={colorByDifficulty}
            addGrila={addGrila}
            books={books}
          />
          {grids?.length === 0 ? null : (
            <Tooltip title="Filtre">
              <LuSettings2
                className="block cursor-pointer text-over-secondary-background absolute right-[10px] top-[70px]"
                onClick={() => {
                  setOpen(true)
                }}
              />
            </Tooltip>
          )}
        </CustomTabPanel>
      ) : null}
      {filterOnMobile === 2 ? (
        <CustomTabPanel value={filterOnMobile} index={2}>
          {createdSubject !== undefined ? (
            <CreatedSubject createdSubject={createdSubject} />
          ) : (
            <SubjectsHistory isLoading={isLoading} subjects={subjects} />
          )}
        </CustomTabPanel>
      ) : null}
    </>
  )
}

export default HistoryContent
